import React from 'react'
import { Link } from 'gatsby'
import { VisuallyHidden } from '@reach/visually-hidden'
import Heading from 'shared/ui/Heading'
import './AboutUs.scss'

function AboutUs() {
  return (
    <section className="about-us spacing">
      <h1>About us</h1>
      <div className="about-us-content spacing">
        <Heading as="p" size={2}>
          We train on how React works and how to think correctly in React
        </Heading>
        <p>
          We serve a range of companies from, small start-ups to the biggest and most well known
          brands in the world. React's capabilities are suitable for many types and sizes of
          projects. Our goal is to deliver comprehensive education about React and to embrace the
          diverse groups who wish to learn.
        </p>
        <Link
          to="/corporate-training"
          className="block button"
          aria-label="Learn More about corporate training"
        >
          Learn More
        </Link>
      </div>
    </section>
  )
}

export default AboutUs
